module.exports = __webpack_public_path__ + "images/patterns/dark/Scale.ae4bae58d864bbbc9091.svg";